import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const OutstandingItemsLoadingCard: React.FC = () => {
  const intl = useIntl()
  const loadingLabel = intl.formatMessage({
    id: 'home.outstandingItems.loading',
    defaultMessage: 'Loading outstanding items...',
  })

  return (
    <section
      aria-busy="true"
      aria-live="polite"
      aria-label={loadingLabel}
      className="border-border-base rounded-xl border bg-white p-6 shadow-lg shadow-gray-900/10 dark:bg-gray-900"
    >
      <div className="flex min-h-44 flex-col items-center justify-center gap-3">
        <svg className="text-brand-600 h-6 w-6 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <p className="text-text-body text-sm font-medium dark:text-gray-300">
          <FormattedMessage id="home.outstandingItems.loading" defaultMessage="Loading outstanding items..." />
        </p>
      </div>
    </section>
  )
}

export default OutstandingItemsLoadingCard
